// extracted by mini-css-extract-plugin
module.exports = {"wrap":"EgiftLineup_wrap__qUS_q","cell":"EgiftLineup_cell__bhKKA","productName":"EgiftLineup_productName__zq9UZ","singleLine":"EgiftLineup_singleLine__vkKL0"};